import { format, endOfDay } from 'date-fns';

import { ISO_FORMAT } from './constants';
import { getDate } from './getDate';

export const getEndOfDay = (date: string, dateFormat = ISO_FORMAT) => {
  const parsedDate = getDate(date, dateFormat);
  if (!parsedDate) return '';

  const end = endOfDay(parsedDate);
  return format(end, dateFormat);
};
